import { $api } from '@/store/ApiClient';
import { CANCEL_CONTRACT, EXPIRE_CONTRACT } from '@/api/target/twInvoiceApi';

export default {
  data() {
    return {};
  },
  methods: {
    // Expire contract
    async expireContract(contractData) {
      await this.$store.dispatch(
        'SHOW_CONFIRM',
        `Are you sure you want to expire this contract? \r\n Company ID: ${contractData.companyId} \r\n Contract Range: ${contractData.signedStartMonth} to ${contractData.signedEndMonth}`
      );

      const params = {
        lslConfig: {
          ...EXPIRE_CONTRACT,
          path: {
            contractId: contractData.contractId
          }
        }
      };
      return this._contractRequest(params);
    },

    // Cancel contract
    async cancelContract(contractData) {
      await this.$store.dispatch(
        'SHOW_CONFIRM',
        `Are you sure you want to cancel this contract? \r\n Company ID: ${contractData.companyId} \r\n Contract Range: ${contractData.signedStartMonth} to ${contractData.signedEndMonth}`
      );

      const params = {
        lslConfig: {
          ...CANCEL_CONTRACT,
          path: {
            contractId: contractData.contractId
          }
        }
      };
      return this._contractRequest(params);
    },

    // Call API
    async _contractRequest(params) {
      this.loading = true;

      return $api.request(params)
        .then(response => {
          if (response) {
            this.$store.dispatch('SHOW_COMPLETED');
          }
        })
        .catch(err => {
          if (err.response?.message) {
            this.$store.dispatch('SHOW_ALERT', err.response.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
